// Text with **bold** and [label](url) links, used by the blog posts and the page articles (SeoArticle).
// Links to other sites open in a new tab.
export default function RichText({ text }) {
  const parts = [];
  const re = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1]) parts.push(<b key={m.index}>{m[1]}</b>);
    else parts.push(<a key={m.index} href={m[3]} {...(m[3].startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>{m[2]}</a>);
    last = re.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
